/* global crypto */
(function (global) {
  'use strict';

  var STORAGE_PREFIX = 'client-wishlist:v1';
  var MAX_WRITE_ATTEMPTS = 3;
  var MAX_OPERATION_POLLS = 6;
  var MAX_RELOAD_REPLAYS = 2;
  var MAX_LEGACY_BOOST_PRICE_READS = 6;
  var THEME_SIGNATURE_API_ROOT = 'https://client-api-staging.58f-test.workers.dev/v1/storefront/wishlist';
  var THEME_SIGNATURE_AUTH_TTL_MS = 4 * 60 * 1000;
  var THEME_SIGNATURE_MAX_AGE_SECONDS = 5 * 60;
  var THEME_SIGNATURE_FUTURE_SKEW_SECONDS = 30;
  var THEME_SIGNATURE_EXPIRY_MARGIN_MS = 1000;
  var ACTIVE_OPERATION = { accepted: true, in_progress: true, ambiguous: true };
  var TERMINAL_SUCCESS = { succeeded: true };
  var TERMINAL_FAILURE = { failed_definitive: true };
  var UNCERTAIN_TERMINAL = { failed_unconfirmed: true, manual_review: true };

  function safeJson(value, fallback) {
    try { return value ? JSON.parse(value) : fallback; } catch (_) { return fallback; }
  }

  function nowId() {
    if (global.crypto && typeof global.crypto.randomUUID === 'function') return global.crypto.randomUUID();
    return String(Date.now()) + '-' + Math.random().toString(16).slice(2);
  }

  function itemKey(item) { return String(item.product_id) + ':' + String(item.variant_id); }
  function productKey(item) { return String(item.product_id); }
  function legacyBoostProductJsonUrl(url) {
    var path = String(url || '').replace(/^https?:\/\/[^/]+/i, '').split(/[?#]/)[0];
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+$/i.test(path)) return null;
    return path + '.js';
  }
  function isThemeSignatureConfig(config) {
    return Boolean(config && !config.previewMock && config.transport === 'theme_signature' && config.directApiRoot === THEME_SIGNATURE_API_ROOT && isThemeAuthUrl(config.authUrl) && config.themeId != null);
  }
  function isThemeAuthUrl(value) {
    return typeof value === 'string' && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?account\?view=wishlist-auth$/i.test(value);
  }
  function isNumericId(value) {
    return (typeof value === 'string' || typeof value === 'number') && /^[1-9][0-9]*$/.test(String(value));
  }
  function base64UrlUtf8(value) {
    if (typeof global.btoa !== 'function') return null;
    try {
      var bytes = encodeURIComponent(String(value)).replace(/%([0-9A-F]{2})/g, function (_, hex) { return String.fromCharCode(parseInt(hex, 16)); });
      return global.btoa(bytes).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    } catch (_) { return null; }
  }
  function parseThemeAuthorization(body, themeId, customerId, nowSeconds) {
    var claims = body && body.claims;
    if (!claims || typeof claims !== 'object' || !/^[0-9a-f]{64}$/.test(String(body.signature || ''))) return null;
    if (!claims.shop || !claims.customer_id || !claims.email || typeof claims.shop !== 'string' || typeof claims.customer_id !== 'string' || typeof claims.email !== 'string') return null;
    if (!isNumericId(claims.customer_id) || !isNumericId(String(themeId)) || !isNumericId(customerId)) return null;
    if (typeof claims.theme_id !== 'string' || claims.theme_id !== String(themeId) || claims.customer_id !== String(customerId)) return null;
    if (!Number.isSafeInteger(claims.issued_at) || claims.issued_at <= 0 || claims.issued_at < nowSeconds - THEME_SIGNATURE_MAX_AGE_SECONDS || claims.issued_at > nowSeconds + THEME_SIGNATURE_FUTURE_SKEW_SECONDS) return null;
    var encodedClaims = base64UrlUtf8(JSON.stringify(claims));
    return encodedClaims ? { value: 'Wishlist ' + encodedClaims + '.' + body.signature, issuedAt: claims.issued_at } : null;
  }
  function operationState(operation) {
    var state = operation && typeof operation.operation_id === 'string' && typeof operation.updated_at === 'string' ? String(operation.state || '').toLowerCase() : '';
    return ACTIVE_OPERATION[state] || TERMINAL_SUCCESS[state] || TERMINAL_FAILURE[state] || UNCERTAIN_TERMINAL[state] ? state : null;
  }
  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }
  function wait(milliseconds) { return new Promise(function (resolve) { global.setTimeout(resolve, milliseconds); }); }
  function message(key) {
    var french = global.document && global.document.documentElement && /^fr(?:-|$)/i.test(global.document.documentElement.lang || '');
    var copy = french ? {
      adding: 'Ajout à votre wishlist en cours.', removing: 'Retrait de l’article de votre wishlist en cours.',
      added: 'Ajouté à votre wishlist.', removed: 'Retiré de votre wishlist.',
      failed: 'Nous n’avons pas pu mettre à jour votre wishlist. Veuillez réessayer.',
      uncertain: 'La mise à jour de votre wishlist n’a pas pu être confirmée. Votre liste actuelle est conservée.',
      waiting: 'La mise à jour de votre wishlist attend une confirmation.',
      empty: 'Votre wishlist est vide.', remove: 'Retirer de la wishlist', soldout: 'Épuisé', cart: 'Ajouter au panier', cartAdding: 'Ajout au panier…', cartAdded: 'Ajouté au panier.', cartFailed: 'Impossible d’ajouter cet article au panier. Veuillez réessayer.', cartUncertain: 'Nous n’avons pas pu confirmer l’ajout au panier. Vérifiez votre panier avant de réessayer.'
    } : {
      adding: 'Adding to wishlist…', removing: 'Removing from wishlist…',
      added: 'Added to wishlist.', removed: 'Removed from wishlist.',
      failed: 'We could not update this wishlist item. Please try again.',
      uncertain: 'This wishlist update could not be confirmed. Your current list is retained.',
      waiting: 'This wishlist update is waiting for confirmation.',
      empty: 'Your wishlist is empty.', remove: 'Remove item from wishlist', soldout: 'Sold out', cart: 'Add to cart', cartAdding: 'Adding to cart…', cartAdded: 'Added to cart.', cartFailed: 'We could not add this item to the cart. Please try again.', cartUncertain: 'We could not confirm this cart update. Check your cart before trying again.'
    };
    return copy[key];
  }

  function Store(config) {
    this.config = config || {};
    this.adapter = this.config.previewMock ? global.ClientWishlistPreviewMock : null;
    this.customerId = this.config.customerId || null;
    this.generation = 0;
    this.items = [];
    this.products = {};
    this.writeToken = null;
    this.queues = {};
    this.inflight = {};
    this.desired = {};
    this.attempted = {};
    this.error = null;
    this.errorKey = null;
    this.feedback = null;
    this.feedbackKind = null;
    this.feedbackVersion = 0;
    this.successKey = null;
    this.cartState = {};
    this.directMode = isThemeSignatureConfig(this.config);
    this.themeAuthorization = null;
    this.themeAuthorizationExpiresAt = 0;
    this.listeners = [];
  }

  Store.prototype.storageKey = function (kind) {
    return (this.config.storagePrefix || STORAGE_PREFIX) + ':' + kind + ':' + (this.customerId || 'guest');
  };
  Store.prototype.guestStorageKey = function () { return (this.config.storagePrefix || STORAGE_PREFIX) + ':guest-items:guest'; };
  Store.prototype.read = function (kind, fallback) {
    return safeJson(global.localStorage && global.localStorage.getItem(this.storageKey(kind)), fallback);
  };
  Store.prototype.write = function (kind, value) {
    if (global.localStorage) global.localStorage.setItem(this.storageKey(kind), JSON.stringify(value));
  };
  Store.prototype.remove = function (kind) {
    if (global.localStorage) global.localStorage.removeItem(this.storageKey(kind));
  };
  Store.prototype.emit = function () {
    this.listeners.forEach(function (listener) { listener(); });
  };
  Store.prototype.onChange = function (listener) { this.listeners.push(listener); };
  Store.prototype.snapshot = function () {
    return { items: this.items.slice(), products: this.products, customerId: this.customerId, error: this.error };
  };
  Store.prototype.setItems = function (items, products) {
    var byProduct = {};
    (Array.isArray(items) ? items : []).forEach(function (item) {
      if (item && item.product_id && item.variant_id) byProduct[String(item.product_id)] = { product_id: String(item.product_id), variant_id: String(item.variant_id) };
    });
    this.items = Object.keys(byProduct).map(function (key) { return byProduct[key]; });
    this.products = products || this.products || {};
    this.write('snapshot', { items: this.items, products: this.products, error: this.error });
    this.emit();
  };
  Store.prototype.loadSnapshot = function () {
    var saved = this.read('snapshot', { items: [], products: {} });
    this.items = Array.isArray(saved.items) ? saved.items : [];
    this.products = saved.products || {};
    this.error = typeof saved.error === 'string' ? saved.error : null;
  };
  Store.prototype.rehydrateLegacyBoostPrices = async function () {
    if (!this.config.previewMock) return;
    var generation = this.generation;
    var changed = false;
    var reads = 0;
    for (var index = 0; index < this.items.length && reads < MAX_LEGACY_BOOST_PRICE_READS; index += 1) {
      if (generation !== this.generation) return;
      var item = this.items[index];
      var key = itemKey(item);
      var product = this.products[key];
      if (!product || product.price_source || !/^https?:\/\//i.test(String(product.url || ''))) continue;
      var url = legacyBoostProductJsonUrl(product.url);
      if (!url) continue;
      reads += 1;
      try {
        var response = await global.fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (generation !== this.generation || !response.ok) continue;
        var body = safeJson(await response.text(), null);
        if (generation !== this.generation || !body || !Array.isArray(body.variants)) continue;
        var variant = body.variants.find(function (candidate) { return candidate && String(candidate.id) === String(item.variant_id); });
        var minorPrice = variant && Number(variant.price);
        if (!Number.isSafeInteger(minorPrice) || minorPrice < 0) continue;
        product.price = String(minorPrice / 100);
        product.price_source = 'shopify-product-json-v1';
        changed = true;
      } catch (_) { /* Keep the last rendered cache when a public product read is unavailable. */ }
    }
    if (changed && generation === this.generation) this.setItems(this.items, this.products);
  };
  Store.prototype.clearThemeAuthorization = function () {
    this.themeAuthorization = null;
    this.themeAuthorizationExpiresAt = 0;
  };
  Store.prototype.setCustomer = function (customerId) {
    if (this.customerId === (customerId || null)) return;
    this.customerId = customerId || null;
    this.generation += 1;
    this.writeToken = null;
    this.queues = {};
    this.inflight = {};
    this.desired = {};
    this.attempted = {};
    this.errorKey = null;
    this.feedback = null;
    this.feedbackKind = null;
    this.feedbackVersion += 1;
    this.successKey = null;
    this.clearThemeAuthorization();
    this.loadSnapshot();
    this.emit();
  };
  Store.prototype.getThemeAuthorization = async function (generation) {
    if (!this.directMode) throw new Error('wishlist_theme_signature_unavailable');
    if (this.themeAuthorization && Date.now() < this.themeAuthorizationExpiresAt) return this.themeAuthorization;
    var authUrl = this.config.authUrl + (this.config.authUrl.indexOf('?') >= 0 ? '&' : '?') + '_=' + Date.now();
    var response = await global.fetch(authUrl, { credentials: 'same-origin', cache: 'no-store', redirect: 'error', headers: { Accept: 'application/json' } });
    if (generation !== this.generation || !response.ok) throw new Error('wishlist_theme_auth_unavailable');
    var body = safeJson(await response.text(), null);
    if (generation !== this.generation) throw new Error('wishlist_theme_auth_stale');
    var now = Date.now();
    var authorization = parseThemeAuthorization(body, this.config.themeId, this.customerId, Math.floor(now / 1000));
    if (!authorization) throw new Error('wishlist_theme_auth_unavailable');
    this.themeAuthorization = authorization.value;
    this.themeAuthorizationExpiresAt = Math.min(now + THEME_SIGNATURE_AUTH_TTL_MS, authorization.issuedAt * 1000 + THEME_SIGNATURE_MAX_AGE_SECONDS * 1000 - THEME_SIGNATURE_EXPIRY_MARGIN_MS);
    return this.themeAuthorization;
  };
  Store.prototype.request = async function (path, options) {
    var response;
    if (this.config.previewMock) {
      if (!this.adapter || typeof this.adapter.request !== 'function') throw new Error('wishlist_mock_unavailable');
      response = await this.adapter.request(path, options || {}, Boolean(this.customerId));
    } else if (this.directMode) {
      var generation = this.generation;
      var authorization = await this.getThemeAuthorization(generation);
      if (generation !== this.generation) throw new Error('wishlist_theme_auth_stale');
      var directOptions = Object.assign({}, options || {});
      directOptions.credentials = 'omit';
      directOptions.headers = Object.assign({}, (options && options.headers) || {}, { Authorization: authorization });
      response = await global.fetch(THEME_SIGNATURE_API_ROOT + path, directOptions);
      if (response.status === 401) this.clearThemeAuthorization();
    } else {
      response = await global.fetch(this.config.proxyRoot.replace(/\/$/, '') + path, options || {});
    }
    var body = safeJson(await response.text(), null);
    return { response: response, body: body };
  };
  Store.prototype.fetchSnapshot = async function () {
    var generation = this.generation;
    var result = await this.request('', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (result.response.status === 401) return false;
    if (!result.response.ok || !result.body || !Array.isArray(result.body.items) || !Array.isArray(result.body.products)) throw new Error('wishlist_unavailable');
    if (generation !== this.generation) return false;
    var products = {};
    result.body.products.forEach(function (product) { products[itemKey(product)] = product; });
    this.writeToken = result.body.write_token || null;
    this.setItems(result.body.items, products);
    this.overlayPending();
    return true;
  };
  Store.prototype.isSaved = function (productId, variantId) {
    return this.items.some(function (item) { return String(item.product_id) === String(productId); });
  };
  Store.prototype.setLocal = function (item, saved) {
    var key = itemKey(item);
    var productId = productKey(item);
    var previousProducts = this.products;
    var items = this.items.filter(function (existing) { return String(existing.product_id) !== productId; });
    Object.keys(this.products).forEach(function (productKeyValue) {
      if (productKeyValue.indexOf(productId + ':') === 0) delete previousProducts[productKeyValue];
    });
    if (saved) items.push({ product_id: String(item.product_id), variant_id: String(item.variant_id) });
    if (saved && item.title) this.products[key] = item;
    this.setItems(items, this.products);
  };
  Store.prototype.showFeedback = function (copy, kind, duration) {
    var self = this;
    this.feedback = copy || null;
    this.feedbackKind = copy ? kind : null;
    var version = ++this.feedbackVersion;
    if (copy && duration && global.document && global.document.createElement) {
      global.setTimeout(function () {
        if (self.feedbackVersion !== version) return;
        self.feedback = null;
        self.feedbackKind = null;
        self.emit();
      }, duration);
    }
  };
  Store.prototype.setError = function (message, key) {
    this.error = message || null;
    this.errorKey = message ? (key || null) : null;
    if (message) this.showFeedback(message, 'error', 5000);
    this.write('snapshot', { items: this.items, products: this.products, error: this.error });
    this.emit();
  };
  Store.prototype.pending = function () {
    var entries = this.read('pending', []);
    return Array.isArray(entries) ? entries.filter(function (entry) {
      return entry && entry.product_id && entry.idempotencyKey && typeof entry.saved === 'boolean';
    }).map(function (entry) {
      return Object.assign({}, entry, { product_id: String(entry.product_id), variant_id: String(entry.variant_id || ''), key: productKey(entry), replayCount: Number.isSafeInteger(entry.replayCount) && entry.replayCount >= 0 ? entry.replayCount : 0, guestMerge: entry.guestMerge === true, blocked: entry.blocked === true });
    }) : [];
  };
  Store.prototype.savePending = function (pending) { this.write('pending', pending); };
  Store.prototype.addPending = function (intent) {
    var pending = this.pending();
    if (!pending.some(function (entry) { return entry.idempotencyKey === intent.idempotencyKey; })) {
      pending.push(intent);
      this.savePending(pending);
    }
  };
  Store.prototype.replacePending = function (intent) {
    this.savePending(this.pending().map(function (entry) {
      return entry.idempotencyKey === intent.idempotencyKey ? intent : entry;
    }));
  };
  Store.prototype.finishPending = function (intent) {
    this.savePending(this.pending().filter(function (entry) {
      return entry.idempotencyKey !== intent.idempotencyKey;
    }));
  };
  Store.prototype.isLatestPending = function (intent) {
    var entries = this.pending().filter(function (entry) { return entry.key === intent.key; });
    return !entries.length || entries[entries.length - 1].idempotencyKey === intent.idempotencyKey;
  };
  Store.prototype.blockGuestMerge = function (intent) {
    intent.blocked = true;
    this.replacePending(intent);
  };
  Store.prototype.finishGuestMerge = function (intent) {
    if (!intent.guestMerge || !global.localStorage) return;
    var guestKey = this.guestStorageKey();
    var guestItems = safeJson(global.localStorage.getItem(guestKey), []);
    if (!Array.isArray(guestItems)) return;
    guestItems = guestItems.filter(function (item) { return String(item.product_id) !== String(intent.product_id); });
    if (guestItems.length) global.localStorage.setItem(guestKey, JSON.stringify(guestItems));
    else global.localStorage.removeItem(guestKey);
  };
  Store.prototype.overlayPending = function () {
    var latest = {};
    this.pending().forEach(function (entry) { if (!entry.blocked) latest[entry.key] = entry; });
    Object.keys(latest).forEach(function (key) { this.setLocal(latest[key], latest[key].saved); }, this);
  };
  Store.prototype.headers = function (intent) {
    return {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Idempotency-Key': intent.idempotencyKey,
      'X-Wishlist-Write-Token': this.writeToken || ''
    };
  };
  Store.prototype.refreshWriteToken = async function (generation) {
    this.writeToken = null;
    if (!await this.fetchSnapshot() || generation !== this.generation || !this.writeToken) return false;
    return true;
  };
  Store.prototype.writeIntent = async function (intent, generation) {
    var path = '/products/' + encodeURIComponent(intent.product_id);
    var options = intent.saved ? { method: 'PUT', body: JSON.stringify({ variant_id: String(intent.variant_id) }) } : { method: 'DELETE' };
    var refreshed = false;
    for (var attempt = 0; attempt < MAX_WRITE_ATTEMPTS; attempt += 1) {
      if (generation !== this.generation) return { stale: true };
      try {
        var expiry = /^([0-9]{10})\.[0-9a-f]{64}$/.exec(this.writeToken || '');
        if (!this.writeToken || (expiry && Number(expiry[1]) * 1000 <= Date.now() + 5000)) {
          if (!await this.refreshWriteToken(generation)) return generation !== this.generation ? { stale: true } : { retryable: true };
        }
        if (generation !== this.generation) return { stale: true };
        var result = await this.request(path, Object.assign({ credentials: 'same-origin', headers: this.headers(intent) }, options));
        if (generation !== this.generation) return { stale: true };
        if (result.response.status === 403 && result.body && result.body.error && result.body.error.code === 'invalid_write_token' && !refreshed) {
          refreshed = true;
          if (!await this.refreshWriteToken(generation)) return generation !== this.generation ? { stale: true } : { retryable: true };
          // This rejection precedes mutation acceptance; preserve the write retry budget and key.
          attempt -= 1;
          continue;
        }
        if ((result.response.status === 200 || result.response.status === 202) && operationState(result.body)) {
          return this.resolveOperation(result.body, intent, generation);
        }
        if (result.response.status >= 500) throw new Error('wishlist_unavailable');
        return { failed: true };
      } catch (_) {
        if (attempt + 1 < MAX_WRITE_ATTEMPTS) {
          await wait(200 * (attempt + 1));
          if (generation !== this.generation) return { stale: true };
        }
      }
    }
    return { retryable: true };
  };
  Store.prototype.resolveOperation = async function (operation, intent, generation) {
    if (generation !== this.generation) return { stale: true };
    var state = operationState(operation);
    if (!state) return { failed: true };
    if (TERMINAL_SUCCESS[state]) return { success: true };
    if (TERMINAL_FAILURE[state]) return { failed: true };
    if (UNCERTAIN_TERMINAL[state]) return { uncertain: true };
    for (var poll = 0; poll < MAX_OPERATION_POLLS; poll += 1) {
      await wait(250 * (poll + 1));
      if (generation !== this.generation) return { stale: true };
      var result;
      try { result = await this.request('/operations/' + encodeURIComponent(operation.operation_id), { credentials: 'same-origin', headers: { Accept: 'application/json' } }); } catch (_) { continue; }
      if (generation !== this.generation) return { stale: true };
      if (!result.response.ok || !result.body) continue;
      state = operationState(result.body);
      if (!state) return { failed: true };
      if (TERMINAL_SUCCESS[state]) return { success: true };
      if (TERMINAL_FAILURE[state]) return { failed: true };
      if (UNCERTAIN_TERMINAL[state]) return { uncertain: true };
    }
    return { retryable: true };
  };
  Store.prototype.runIntent = function (intent) {
    var self = this;
    var key = intent.key;
    var generation = this.generation;
    var previous = this.queues[key] || Promise.resolve();
    var queued = previous.then(async function () {
      if (generation !== self.generation) return { stale: true };
      self.attempted[intent.idempotencyKey] = true;
      var result = await self.writeIntent(intent, generation);
      if (generation !== self.generation || result.stale) return { stale: true };
      var latest = self.isLatestPending(intent);
      if (result.success) {
        self.finishPending(intent);
        self.finishGuestMerge(intent);
        if (latest) {
          self.successKey = intent.saved ? intent.key : null;
          self.showFeedback(message(intent.saved ? 'added' : 'removed'), 'success', 2200);
          self.setLocal(intent, intent.saved);
          self.setError(null);
        }
        return result;
      }
      if (result.failed) {
        if (intent.guestMerge) self.blockGuestMerge(intent);
        else self.finishPending(intent);
        if (latest) {
          self.setLocal(intent, !intent.saved);
          self.setError(message('failed'), intent.key);
        }
        return result;
      }
      if (result.uncertain) {
        if (intent.guestMerge) self.blockGuestMerge(intent);
        else self.finishPending(intent);
        if (latest) self.setError(message('uncertain'), intent.key);
        return result;
      }
      if (latest) self.setError(message('waiting'), intent.key);
      return result;
    }).finally(function () {
      if (self.inflight[key] === queued) {
        delete self.inflight[key];
        self.emit();
      }
    });
    this.queues[key] = queued;
    this.inflight[key] = queued;
    this.emit();
    return queued;
  };
  Store.prototype.intent = function (item, saved, analytics) {
    var intent = Object.assign({}, item, { saved: saved, key: productKey(item), idempotencyKey: nowId(), replayCount: 0 });
    if (saved && this.config.previewMock && this.adapter && typeof this.adapter.rememberProduct === 'function') this.adapter.rememberProduct(intent);
    this.desired[intent.key] = intent.idempotencyKey;
    this.addPending(intent);
    this.errorKey = null;
    this.successKey = !this.customerId && saved ? intent.key : null;
    this.showFeedback(message(!this.customerId ? (saved ? 'added' : 'removed') : (saved ? 'adding' : 'removing')), !this.customerId ? 'success' : 'pending', !this.customerId ? 2200 : 0);
    this.setLocal(intent, saved);
    this.setError(null);
    if (!this.config.previewMock && analytics && saved) analytics(intent);
    if (!this.customerId) {
      this.write('guest-items', this.items.map(function (entry) { return Object.assign({}, entry, this.products[itemKey(entry)] || {}); }, this));
      this.finishPending(intent);
      return Promise.resolve({ local: true });
    }
    return this.runIntent(intent);
  };
  Store.prototype.mergeGuest = async function () {
    if (!this.customerId) return;
    var generation = this.generation;
    var guestKey = this.guestStorageKey();
    var guestItems = safeJson(global.localStorage && global.localStorage.getItem(guestKey), []);
    if (!Array.isArray(guestItems) || !guestItems.length) return;
    for (var index = 0; index < guestItems.length; index += 1) {
      if (generation !== this.generation) return false;
      var item = guestItems[index];
      if (!item || !item.product_id || !item.variant_id) continue;
      if (this.pending().some(function (entry) { return entry.guestMerge && entry.key === productKey(item); })) continue;
      var intent = { product_id: item.product_id, variant_id: item.variant_id, saved: true, key: productKey(item), idempotencyKey: nowId(), replayCount: 0, guestMerge: true };
      this.addPending(intent);
      var result = await this.runIntent(intent);
      if (generation !== this.generation) return false;
      if (!result.success) return false;
      guestItems.splice(index, 1);
      index -= 1;
      if (global.localStorage) global.localStorage.setItem(guestKey, JSON.stringify(guestItems));
    }
    if (generation !== this.generation) return false;
    if (global.localStorage && !guestItems.length) global.localStorage.removeItem(guestKey);
    await this.fetchSnapshot();
    return generation === this.generation;
  };
  Store.prototype.resumePending = async function () {
    var generation = this.generation;
    var entries = this.pending();
    if (generation !== this.generation) return;
    entries.forEach(function (entry) { this.desired[entry.key] = entry.idempotencyKey; }, this);
    this.overlayPending();
    for (var index = 0; index < entries.length; index += 1) {
      if (generation !== this.generation) return;
      var intent = entries[index];
      if (intent.blocked) continue;
      if (!this.pending().some(function (entry) { return entry.idempotencyKey === intent.idempotencyKey; }) || this.attempted[intent.idempotencyKey]) continue;
      if (intent.replayCount >= MAX_RELOAD_REPLAYS) {
        var latest = this.isLatestPending(intent);
        if (intent.guestMerge) this.blockGuestMerge(intent);
        else this.finishPending(intent);
        if (latest) this.setError(message('uncertain'), intent.key);
        continue;
      }
      intent.replayCount += 1;
      this.replacePending(intent);
      await this.runIntent(intent);
      if (generation !== this.generation) return;
    }
  };

  function itemFromElement(element) {
    var data = element.dataset || {};
    var selected = element.closest && element.closest('form[data-product-form]');
    if (!selected && data.clientWishlistGallery === 'true') {
      var productRoot = element.closest && element.closest('.product--outer');
      selected = productRoot && productRoot.querySelector('form[data-product-form]');
    }
    var variant = selected && selected.querySelector('[data-variants]');
    var price = data.productPrice || '0';
    if (data.productPriceUnit === 'minor') {
      var minorPrice = Number(price);
      price = Number.isFinite(minorPrice) ? String(minorPrice / 100) : '0';
    }
    return {
      product_id: data.productId,
      variant_id: (variant && variant.value && variant.value !== 'not-selected') ? variant.value : data.variantId,
      title: data.productTitle || '', url: data.productUrl || '', image_url: data.productImage || null,
      price: price, currency: data.productCurrency || '', vendor: data.productVendor || '',
      sku: data.productSku || null, category: data.productCategory || '', price_source: data.productPriceSource || null, available: data.productAvailable !== 'false'
    };
  }
  function renderFeedback(store) {
    if (!global.document) return;
    var live = global.document.querySelector && global.document.querySelector('[data-client-wishlist-live]');
    if (!live && global.document.createElement && global.document.body) {
      live = global.document.createElement('div');
      live.className = 'client-wishlist-feedback';
      live.setAttribute('data-client-wishlist-live', '');
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      global.document.body.appendChild(live);
    }
    if (!live) return;
    var copy = store.feedback || '';
    if (live.classList) {
      live.classList.remove('visually-hidden');
      live.classList.toggle('is-visible', Boolean(copy));
      live.classList.toggle('is-pending', store.feedbackKind === 'pending');
      live.classList.toggle('is-error', store.feedbackKind === 'error' || Boolean(store.error));
    }
    live.textContent = copy;
  }
  function renderControls(store) {
    if (!global.document) return;
    var buttons = global.document.querySelectorAll('[data-client-wishlist-toggle]');
    buttons.forEach(function (button) {
      var item = itemFromElement(button);
      var key = productKey(item);
      var saved = store.isSaved(item.product_id, item.variant_id);
      var busy = Boolean(store.inflight[key]);
      button.classList.toggle('is-saved', saved);
      button.classList.toggle('is-busy', busy);
      button.classList.toggle('is-confirmed', store.successKey === key && saved);
      button.classList.toggle('has-error', Boolean(store.error && (!store.errorKey || store.errorKey === key)));
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-busy', String(busy));
      button.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Add to wishlist');
      var label = button.querySelector('[data-client-wishlist-label]');
      if (label) label.textContent = saved ? 'Remove from wishlist' : 'Add to wishlist';
    });
    global.document.querySelectorAll('[data-client-wishlist-count]').forEach(function (count) { count.textContent = String(store.items.length); });
    renderFeedback(store);
  }
  function formatPrice(product) {
    if (!product.currency) return '';
    var amount = Number(product.price);
    if (typeof Intl !== 'undefined' && Number.isFinite(amount)) {
      try {
        return new Intl.NumberFormat(global.document && global.document.documentElement ? global.document.documentElement.lang : undefined, { style: 'currency', currency: product.currency }).format(amount);
      } catch (_) { /* use the provider's display value below */ }
    }
    return String(product.price || '') + ' ' + String(product.currency);
  }
  function renderWishlist(store) {
    if (!global.document) return;
    var target = global.document.getElementById('wishlist-items-container');
    if (!target) return;
    var status = store.error ? '<p class="client-wishlist-status">' + escapeHtml(store.error) + '</p>' : '';
    if (!store.customerId) {
      target.innerHTML = status + '<p>Please sign in to view your wishlist.</p>';
      return;
    }
    if (!store.items.length) { target.innerHTML = status + '<p>' + escapeHtml(message('empty')) + '</p>'; return; }
    target.innerHTML = status + '<div class="client-wishlist-grid">' + store.items.map(function (entry) {
      var product = store.products[itemKey(entry)] || entry;
      var unavailable = product.available === false;
      var offer = store.config.showOffer && !unavailable ? '<a class="button-primary button--sm button--account w-full" data-fancybox-popup data-src="#make-offer-popup" data-make-offer-popup data-variant-id="' + escapeHtml(entry.variant_id) + '" data-product-id="' + escapeHtml(entry.product_id) + '" data-product-url="' + escapeHtml(product.url) + '" data-product-price="' + escapeHtml(product.price) + '" data-product-title="' + escapeHtml(product.title) + '">Make an offer</a>' : '';
      var formattedPrice = formatPrice(product);
      var price = formattedPrice ? '<p class="client-wishlist-item__price">' + escapeHtml(formattedPrice) + '</p>' : '';
      var cartState = store.cartState[String(entry.variant_id)] || '';
      var cartLabel = cartState === 'busy' ? message('cartAdding') : cartState === 'uncertain' ? message('cartUncertain') : cartState === 'succeeded' ? message('cartAdded') : message('cart');
      var cartDisabled = cartState ? ' disabled aria-disabled="true"' : '';
      return '<article class="client-wishlist-item' + (unavailable ? ' is-unavailable' : '') + '"><a href="' + escapeHtml(product.url) + '" class="client-wishlist-item__image">' + (product.image_url ? '<img src="' + escapeHtml(product.image_url) + '" alt="" loading="lazy">' : '') + '</a><button type="button" class="client-wishlist-remove" data-client-wishlist-remove data-product-id="' + escapeHtml(entry.product_id) + '" data-variant-id="' + escapeHtml(entry.variant_id) + '" aria-label="' + escapeHtml(message('remove')) + '">×</button>' + price + '<a href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title || '') + '</a>' + (unavailable ? '<p>' + escapeHtml(message('soldout')) + '</p>' : '<div class="client-wishlist-item__actions">' + offer + '<button type="button" class="button-primary button--sm button-primary--alt button--account w-full" data-client-wishlist-cart data-variant-id="' + escapeHtml(entry.variant_id) + '"' + cartDisabled + '>' + escapeHtml(cartLabel) + '</button></div>') + '</article>';
    }).join('') + '</div>';
  }
  function analytics(item, config) {
    if (!global.dataLayer) global.dataLayer = [];
    global.dataLayer.push({ ecommerce: null });
    var product = { item_id: 'shopify_' + (config.countryCode || '') + '_' + item.product_id + '_' + item.variant_id, product_id: String(item.product_id), variant_id: String(item.variant_id), item_name: item.title || '', price: Number(item.price) || 0, quantity: 1 };
    if (item.category) product.item_category = item.category;
    if (item.vendor) product.item_brand = item.vendor;
    if (item.sku) product.sku = item.sku;
    global.dataLayer.push({ event: 'add_to_wishlist', ecommerce: { currency: item.currency || config.currency, value: item.price, items: [product] } });
  }
  function closestControl(target, selector) {
    if (target && target.closest) {
      var closest = target.closest(selector);
      if (closest) return closest;
    }
    for (var element = target; element && element !== global.document; element = element.parentElement || element.parentNode) {
      if (element.matches && element.matches(selector)) return element;
    }
    return null;
  }
  function addToCart(store, button) {
    var variantId = String(button.dataset.variantId || '');
    if (store.cartState[variantId]) return;
    if (!/^[1-9][0-9]*$/.test(variantId)) {
      store.showFeedback(message('cartFailed'), 'error', 5000);
      store.emit();
      return;
    }
    var originalLabel = button.textContent;
    store.cartState[variantId] = 'busy';
    button.disabled = true;
    button.textContent = message('cartAdding');
    store.emit();
    global.fetch(store.config.cartAddUrl || '/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(async function (response) {
      var body = safeJson(await response.text(), null);
      if (!response.ok) {
        if (response.status >= 400 && response.status < 500) {
          delete store.cartState[variantId];
          button.disabled = false;
          button.textContent = originalLabel;
          store.showFeedback(message('cartFailed'), 'error', 5000);
        } else {
          store.cartState[variantId] = 'uncertain';
          button.textContent = message('cartUncertain');
          store.showFeedback(message('cartUncertain'), 'error', 5000);
        }
        store.emit();
        return;
      }
      var added = body && Array.isArray(body.items) && body.items.some(function (item) {
        return item && String(item.variant_id || item.id) === variantId && Number(item.quantity) >= 1;
      });
      if (!added) {
        store.cartState[variantId] = 'uncertain';
        button.textContent = message('cartUncertain');
        store.showFeedback(message('cartUncertain'), 'error', 5000);
        store.emit();
        return;
      }
      store.cartState[variantId] = 'succeeded';
      button.textContent = message('cartAdded');
      store.showFeedback(message('cartAdded'), 'success', 2200);
      store.emit();
      if (store.config.cartUrl && global.location) {
        if (typeof global.location.assign === 'function') global.location.assign(store.config.cartUrl);
        else global.location.href = store.config.cartUrl;
      }
    }).catch(function () {
      store.cartState[variantId] = 'uncertain';
      button.textContent = message('cartUncertain');
      store.showFeedback(message('cartUncertain'), 'error', 5000);
      store.emit();
    });
  }
  function bind(store) {
    if (!global.document) return;
    global.document.addEventListener('click', function (event) {
      var toggle = closestControl(event.target, '[data-client-wishlist-toggle]');
      if (toggle) {
        event.preventDefault();
        if (event.stopPropagation) event.stopPropagation();
        var item = itemFromElement(toggle);
        store.intent(item, !store.isSaved(item.product_id, item.variant_id), function (intent) { analytics(intent, store.config); });
        return;
      }
      var remove = closestControl(event.target, '[data-client-wishlist-remove]');
      if (remove) { store.intent({ product_id: remove.dataset.productId, variant_id: remove.dataset.variantId }, false); return; }
      var cart = closestControl(event.target, '[data-client-wishlist-cart]');
      if (cart) {
        event.preventDefault();
        addToCart(store, cart);
      }
    }, true);
  }
  async function start(config) {
    var store = new Store(config);
    global.__clientWishlistStore = store;
    store.loadSnapshot();
    store.onChange(function () { renderControls(store); renderWishlist(store); });
    bind(store);
    if (store.config.previewMock) {
      if (!store.adapter || typeof store.adapter.request !== 'function') {
        store.setError('Mock wishlist is unavailable. No wishlist request was sent.');
        return store;
      }
      if (typeof store.adapter.mount === 'function') store.adapter.mount(store);
    }
    store.emit();
    if (store.customerId) {
      try { await store.fetchSnapshot(); await store.resumePending(); await store.mergeGuest(); } catch (_) { /* retained snapshot keeps the UI useful during an outage */ }
    } else {
      var guest = store.read('guest-items', []);
      var guestProducts = {};
      (Array.isArray(guest) ? guest : []).forEach(function (item) { guestProducts[itemKey(item)] = item; });
      store.setItems(guest, guestProducts);
    }
    await store.rehydrateLegacyBoostPrices();
    return store;
  }

  global.ClientWishlist = { Store: Store, start: start, renderWishlist: renderWishlist, renderControls: function () { if (global.__clientWishlistStore) renderControls(global.__clientWishlistStore); } };
  if (global.ClientWishlistConfig) start(global.ClientWishlistConfig);
})(window);
